import { type ReactNode } from "react";

export type CardProps = {
  title?: string;
  subtitle?: string;
  trailing?: ReactNode;
  children?: ReactNode;
  /** Tone, adjusts the accent bar at the left. */
  tone?: "neutral" | "accent" | "good" | "warn" | "bad";
};

const TONE_BAR: Record<NonNullable<CardProps["tone"]>, string> = {
  neutral: "bg-line",
  accent: "bg-accent",
  good: "bg-good",
  warn: "bg-warn",
  bad: "bg-bad",
};

export function Card({ title, subtitle, trailing, children, tone = "neutral" }: CardProps) {
  return (
    <article className="rounded-xl border border-line bg-canvas-2 overflow-hidden shadow-sm">
      <div className="grid grid-cols-[3px_1fr] gap-0">
        <div className={TONE_BAR[tone]} />
        <div className="p-5">
          {(title || trailing) && (
            <header className="flex items-start justify-between gap-3 mb-3">
              <div>
                {title && (
                  <h3 className="font-display text-lg leading-tight text-ink">
                    {title}
                  </h3>
                )}
                {subtitle && (
                  <p className="text-sm text-ink-soft mt-0.5">{subtitle}</p>
                )}
              </div>
              {trailing && <div className="shrink-0">{trailing}</div>}
            </header>
          )}
          {children}
        </div>
      </div>
    </article>
  );
}
